
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { Params, RouterModule } from '@angular/router';

import { DirectivesModule } from 'projects/shared/lib/directives/directives.module';


@Component({
    selector: 'app-check-privacy',
    imports: [
    RouterModule,
    DirectivesModule
],
    templateUrl: './check-privacy.component.html',
    styleUrls: ['./check-privacy.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class CheckPrivacyComponent {
  @Input({required: true}) routerlink!: string[] | string;
  @Input() queryParams: Params | null | undefined;

  @Output() onChecked: EventEmitter<boolean> = new EventEmitter<boolean>();

  public checkValue(e: Event): void {
    if (!e.target) {
      return;
    }
    let target = e.target as HTMLInputElement;
    let checked = target.checked;

    this.onChecked.emit(checked);
  }

}